import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Brand,
  Country,
  File,
  Notification,
  Port,
  ProductCountry,
  ProductShipment
} from '@app/models';

import * as ShippingTimeActionTypes from '@core/actions/shipping-time.actions';

import * as ColorActionTypes from '@core/actions/color.actions';
import * as DiscrepancyActions from '@core/actions/discrepancy.actions';
import * as FileActions from '@core/actions/file.actions';
import * as JobActions from '@core/actions/job.actions';
import * as ReportsActions from '@core/actions/reports.actions';
import * as ShippingmarksActions from '@core/actions/shippingmarks.actions';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import * as FileSaver from 'file-saver/FileSaver';

import * as CoverActionTypes from '@app/modules/core/actions/cover.actions';
import * as ProformaActionTypes from '@app/modules/core/actions/proforma.actions';
import * as NewProductFileActions from '@app/modules/file-upload/actions/new-product-file.actions';

import { FollowGroup } from '@app/models/follow-group';
import * as LogsActionTypes from '@app/modules/core/actions/logs.actions';
import * as UserActionTypes from '@app/modules/core/actions/user.actions';

const API = environment.API;

// export interface MoveProductShipmentsUnitsDTO {
//   FollowId: number;
//   CountryId: number;
//   bussinessUnit: string;
//   data: {
//     shipments: { id: number; units: number }[];
//   };
// }

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private http: HttpClient, private store: Store<any>) {}

  downloadProductsImage(data) {
    return this.http
      .get(data.url, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, 'Repositorio de Fotos.xlsx');
        },
        err => {
          this.store.dispatch(new FileActions.DownloadImgFail(err));
        }
      );
  }
  downloadOrderSummary(data) {
    return this.http
      .get(data.url, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Resumen de compra - ${data.FollowId}.xlsx`);
        },
        err => {
          this.store.dispatch(new FileActions.DownloadImgFail(err));
        }
      );
  }

  getTechnicalFileLink(productId, file, followType) {
    const mimeType = file.type;
    const name = file.name;

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      FileableType: followType,
      FileableId: productId,
      metadata: {
        processType: 'uploadTechnicalFile'
      }
    });
  }

  getShippingMarksUploadLink(file) {
    const name = file.name;
    const FileableType = 'ShippingMarksMaster';

    return this.http.post<string>(
      `${API}shippingmarks/upload-shipping-marks-xlsx`,
      {
        mimeType: file.type,
        name,
        FileableType,
        metadata: {
          processType: 'LoadShippingMarksMaster'
        }
      }
    );
  }

  getAlertsByFollowId(FollowId) {
    return this.http.get<any>(`${API}follows/alerts/${FollowId}`);
  }

  getJobInfo(data) {
    const { UserId, FollowId, page } = data;
    return this.http.get<JobActions.Job[]>(
      `${API}files/jobs?UserId=${UserId}&FollowId=${FollowId}&page=${page}`,
      {
        observe: 'response'
      }
    );
  }

  skuValidation(FollowId) {
    return this.http.get<any>(`${API}products/skuValidations/${FollowId}`, {
      observe: 'response'
    });
  }

  deleteBusiness(data) {
    return this.http.delete(
      `${API}businesses/${data.data.FollowId}/udnFollow?businessCountryId=${
        data.data.businessCountryId
      }`
    );
  }

  searchBusinessProductsByFollowId(data: any) {
    return this.http.get<any>(
      `${API}businesses/${
        data.FollowId
      }/ProductsByBusinessFollowId?BusinessId=${data.BusinessId}`
    );
  }

  addBusiness(data: any) {
    return this.http.post(`${API}businesses/udnFollow`, data);
  }

  createBusiness(data: any) {
    return this.http.post(`${API}businesses`, data);
  }

  getBusinessUnitsbyId(data: any) {
    return this.http.get<any>(`${API}businesses/${data.FollowId}`);
  }

  getBusinessUnits(data: any) {
    const query = `${
      data && data.data && data.data.format ? `?format=${data.data.format}` : ''
    }`;
    return this.http.get<any>(`${API}businesses${query}`);
    // return this.http.get<BusinessUnit[]>(`${API}businesses`);
  }

  getFollowGroups() {
    return this.http.get<FollowGroup[]>(`${API}follow_groups`);
  }

  downloadImg(followId) {
    return this.http
      .get(`${API}follows/${followId}/exportImg`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          // const blob = response.body;
          // console.log('zipFiles => ',blob)
          // FileSaver.saveAs(blob, `zipFiles.zip`);
          this.store.dispatch(
            new FileActions.DownloadImgUpdate({
              // status: 'pending',
              // message: 'Generando imágenes...'
            })
          );
        },
        err => {
          this.store.dispatch(new FileActions.DownloadImgFail(err));
        }
      );
  }

  downloadImgZip(downloadUrl, filename) {
    return this.http
      .get(downloadUrl, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, filename);
        },
        err => {
          this.store.dispatch(new FileActions.DownloadImgFail(err));
        }
      );
  }

  exportOCMGlobal(data) {
    const query = `busi=${data.busi ? data.busi : ''}&followIds=${
      data.FollowsIds ? data.FollowsIds : ''
    }`;
    return this.http
      .get(`${API}follows/ocmGlobal?${query}`, {
        observe: 'response'
      })
      .subscribe(
        response => {
          this.store.dispatch(new FileActions.ExportGlobalOcmSuccess());
        },
        err => {
          this.store.dispatch(new FileActions.ExportGlobalOcmFail());
        }
      );
  }

  exportOCM(data) {
    let query = data.type
      ? `?name=${data.nameFile}&FollowId=${data.followId}&type=${data.type}` +
        (data.filter ? `&filter=${data.filter}` : '') +
        (data.uniqTemplateId ? `&uniqTemplateId=${data.uniqTemplateId}` : '')
      : `?name=${data.nameFile}&FollowId=${data.followId}&uniqTemplateId=${
          data.uniqTemplateId
        }`;

    query =
      query +
      (data.busi ? `&busi=${data.busi ? data.busi : ''}` : '') +
      (data.FollowsIds
        ? `&FollowsIds=${data.FollowsIds ? data.FollowsIds : ''}`
        : '');
    if (data.type === 'special_ocm') {
      query = query + `&poNumber=${data.poNumber}`;
    }
    return this.http
      .get(`${API}follows/ExportOcm${query}`, {
        observe: 'response'
      })
      .subscribe(
        response => {
          this.store.dispatch(new FileActions.ExportGlobalOcmSuccess());
        },
        err => {
          this.store.dispatch(new FileActions.ExportGlobalOcmFail());
        }
      );
  }

  uploadSingleImage(data, productId, followId, position) {
    // console.log("API SERVICE")
    let mimeType = data.type;
    const typeUpload = 'image';

    return this.http.post(`${API}files/upload-single-image`, {
      mimeType,
      FileableType: 'Product',
      typeUpload,
      name: data.name,
      productId,
      followId,
      position
    });
  }

  uploadSingleImageSecond(data) {
    return this.http.post(`${API}files/upload-single-image-second`, {
      fileId: data
    });
  }

  getFilesData(followId) {
    return this.http.get(`${API}files/files-data?followId=${followId}`);
  }

  exportMasterKey(name) {
    return this.http.get(`${API}files/exportMasterKey?name=${name}`).subscribe(
      response => {
        this.store.dispatch(
          new FileActions.GenerateTemplate({
            status: 'pending',
            message: 'Generando template...'
            // templateUniqId: templateUniqId
          })
        );
      },
      err => {
        this.store.dispatch(new FileActions.ExportFollowFail());
      }
    );
  }

  exportQuery(name, data) {
    let query = '';
    if (data) {
      query = `&yearsSelected=${data.yearsSelected}&n5Selected=${
        data.n5Selected
      }`;
    }
    return this.http
      .get(`${API}files/ExportQuery?name=${name}${query}`)
      .subscribe(
        response => {
          this.store.dispatch(
            new FileActions.GenerateTemplate({
              status: 'pending',
              message: 'Generando template...'
              // templateUniqId: templateUniqId
            })
          );
        },
        err => {
          this.store.dispatch(new FileActions.ExportFollowFail());
        }
      );
  }

  exportMP(FollowId) {
    return this.http
      .get(`${API}files/exportMP?FollowParentId=${FollowId}`)
      .subscribe(
        response => {
          this.store.dispatch(
            new FileActions.GenerateTemplate({
              status: 'pending',
              message: 'Generando template...'
              // templateUniqId: templateUniqId
            })
          );
        },
        err => {
          this.store.dispatch(new FileActions.ExportFollowFail());
        }
      );
  }

  upsertFollowImg() {
    console.log('is herererer');
    return this.http.get(`${API}files/upsertFollowImg`);
  }

  exportTotalSupplier(part) {
    return this.http
      .get(`${API}files/exportTotalSupplier?part=${part}`)
      .subscribe(
        response => {
          this.store.dispatch(
            new FileActions.GenerateTemplate({
              status: 'pending',
              message: 'Generando template...'
              // templateUniqId: templateUniqId
            })
          );
        },
        err => {
          this.store.dispatch(new FileActions.ExportFollowFail());
        }
      );
  }

  exportFollow(id, name, type, templateUniqId, filter) {
    const query = type
      ? `?name=${name}&type=${type}` +
        (filter ? `&filter=${filter}` : '') +
        (templateUniqId ? `&templateUniqId=${templateUniqId}` : '')
      : `?name=${name}&templateUniqId=${templateUniqId}`;
    return this.http
      .get(`${API}follows/${id}/export${query}`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          if (type === 'ProductImage' || type === 'ProductImageMP') {
            this.store.dispatch(
              new FileActions.ExportFollowPending({
                status: 'pending',
                message: 'Generando Repositorio de Fotos...',
                templateUniqId: templateUniqId
              })
            );
          } else if (type === 'follow_regional_unit') {
            this.store.dispatch(
              new FileActions.GenerateTemplate({
                status: 'pending',
                message: 'Generando template...',
                templateUniqId: templateUniqId
              })
            );
          } else if (type && type !== 'shopping') {
            const blob = response.body;
            FileSaver.saveAs(blob, `${name}.xlsx`);
            this.store.dispatch(new FileActions.ExportFollowSuccess());
          } else {
            this.store.dispatch(
              new FileActions.GenerateTemplate({
                status: 'pending',
                message: 'Generando template...',
                templateUniqId: templateUniqId
              })
            );
          }
          // const blob = response.body;
          // FileSaver.saveAs(blob, `${name}.xlsx`);
          // this.store.dispatch(new FileActions.ExportFollowSuccess());
        },
        err => {
          this.store.dispatch(new FileActions.ExportFollowFail());
        }
      );
  }

  exportOrderSummary(id) {
    return this.http
      .get(`${API}follows/${id}/order-summary`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          this.store.dispatch(
            new FileActions.ExportOrderSummaryPending({
              status: 'pending',
              message: 'Generando Resumen de compra...'
            })
          );
          // const blob = response.body;
          // FileSaver.saveAs(blob, `${name}.xlsx`);
          // this.store.dispatch(new FileActions.ExportFollowSuccess());
        },
        err => {
          this.store.dispatch(new FileActions.ExportOrderSummaryFail(err));
        }
      );
  }

  exportFinanceSummaryXlsxl(id) {
    return this.http
      .get(`${API}follows/${id}/finance-summary`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Resumen de finanzas - ${id}.xlsx`);
        },
        err => {
          this.store.dispatch(new FileActions.ExportOrderSummaryFail(err));
        }
      );
  }

  downloadGlobalOCM(data) {
    const { name, downloadUrl } = data;
    return this.http
      .get(downloadUrl, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, name);
        },
        err => {
          this.store.dispatch(new FileActions.ExportGlobalOcmFail());
        }
      );
  }

  generateTempLink(filePath, fileName) {
    return this.http
      .post(`${API}files/file-url`, { filePath })
      .subscribe(response => {
        this.downloadTemplate({ downloadUrl: response, name: fileName });
      });
  }

  downloadMPTemplate(data) {
    const { fileName, downloadlink } = data;
    return this.http
      .get(downloadlink, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `${fileName}.pdf`);
        },
        err => {
          this.store.dispatch(new FileActions.ExportFollowFail());
        }
      );
  }

  downloadTemplate(data) {
    const { name, downloadUrl } = data;
    return this.http
      .get(downloadUrl, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `${name}.xlsx`);
          // this.store.dispatch(new FileActions.ExportFollowSuccess());
        },
        err => {
          this.store.dispatch(new FileActions.ExportFollowFail());
        }
      );
  }

  exportImplantation(FollowId) {
    return this.http
      .get(`${API}follows/${FollowId}/implantation/export`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Implantation`);
          this.store.dispatch(new FileActions.ExportImplantationSuccess());
        },
        err => {
          this.store.dispatch(new FileActions.ExportImplantationFail());
        }
      );
  }

  exportOrderRecap(FollowId) {
    return this.http
      .get(`${API}follows/${FollowId}/order-recap/export`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Order recap - ${FollowId}`);
          this.store.dispatch(new FileActions.DownloadOrderRecapSuccess());
        },
        err => {
          this.store.dispatch(new FileActions.DownloadOrderRecapFail(err));
        }
      );
  }

  exportOrderRecapProvider(FollowId) {
    return this.http
      .get(`${API}follows/${FollowId}/order-recap/export-providers`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Order recap supplier - ${FollowId}`);
          this.store.dispatch(new FileActions.DownloadOrderRecapProviderSuccess());
        },
        err => {
          this.store.dispatch(new FileActions.DownloadOrderRecapProviderFail(err));
        }
      );
  }

  exportProforma(id, name, type, ArrivalState) {
    // const query = type ? `?type=${type}` : ''
    const query = `?ArrivalState=${ArrivalState}`;
    return this.http
      .get(`${API}proformas/${id}/export${query}`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `${name}.xlsx`);
          this.store.dispatch(new FileActions.ExportProformaSuccess());
        },
        err => {
          this.store.dispatch(new FileActions.ExportProformaFail());
        }
      );
  }

  exportProformasGroup(filter) {
    console.log('SERVICE_exportProformasGroup');
    return this.http.post(`${API}proformas/export`, filter).subscribe(
      response => {
        this.store.dispatch(
          new ProformaActionTypes.ExportGroupUpdate({
            status: 'pending',
            message: 'Generando proformas...',
            exportGroupId: filter.exportGroupId,
            RegionalId: filter.RegionalId || null,
            OriginId: filter.OriginId || null,
            enableShipment: filter.enableShipment || null
          })
        );
      },
      err => {
        this.store.dispatch(new ProformaActionTypes.ExportGroupFail(err));
      }
    );
  }

  downloadProformasGroup(downloadUrl, name) {
    return this.http
      .get(downloadUrl, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, name);
          this.store.dispatch(
            new ProformaActionTypes.ExportGroupDownloadSuccess()
          );
        },
        err => {
          this.store.dispatch(
            new ProformaActionTypes.ExportGroupDownloadFail(err)
          );
        }
      );
  }

  getRules() {
    return this.http.get(`${API}follows/rules`);
  }

  getFollowsNoMembers() {
    return this.http.get(`${API}follows/all-follows`);
  }

  exportFollowColors(id, name, type) {
    let query = Object.keys(type).reduce((q, key) => {
      return `${q}${key}=${type[key]}&`;
    }, '?');
    query = query.slice(0, -1);
    return this.http
      .get(`${API}follows/${id}/colors/export`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, 'colors.xlsx');
          this.store.dispatch(new ColorActionTypes.ExportColorSuccess());
        },
        err => {
          this.store.dispatch(new ColorActionTypes.ExportColorFail());
        }
      );
  }

  exportLogs(date1, date2) {
    const options = {
      date1,
      date2
    };
    // console.log('A PUNTO DE LLEGAR A LA API-->', options);
    return this.http
      .get(
        `${API}revisions/export?startDate=${options.date1}&endDate=${
          options.date2
        }`,
        {
          responseType: 'blob',
          observe: 'response'
        }
      )
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, 'logs.xlsx');
          this.store.dispatch(new LogsActionTypes.ExportLogsSuccess());
        },
        err => {
          this.store.dispatch(new LogsActionTypes.ExportLogsFail());
        }
      );
  }

  exportFollowUsers() {
    // query = query.slice(0, -1);
    return this.http
      .get(`${API}users/export`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, 'users.xlsx');
          this.store.dispatch(new UserActionTypes.ExportUserSuccess());
        },
        err => {
          this.store.dispatch(new UserActionTypes.ExportUserFail());
        }
      );
  }

  exportProviders(data) {
    const options = data;
    const fileName =
      options.mode === 'normalMode'
        ? 'Maestra Proveedor - Info Sar'
        : 'Maestra Proveedor - Info Regional';

    if (options.followGroupsIds || options.mode) {
      return this.http
        .get(
          `${API}providers/export?data=${options.followGroupsIds}&mode=${
            options.mode
          }&name=${fileName}`,
          {
            responseType: 'blob',
            observe: 'response'
          }
        )
        .subscribe(
          response => {
            // const blob = response.body;
            // FileSaver.saveAs(blob, `${fileName}.xlsx`);
            // this.store.dispatch(new FileActions.ExportProformaSuccess());
          },
          err => {
            this.store.dispatch(new FileActions.ExportProformaFail());
          }
        );
    } else {
      return this.http
        .get(`${API}providers/export`, {
          responseType: 'blob',
          observe: 'response'
        })
        .subscribe(
          response => {
            const blob = response.body;
            FileSaver.saveAs(blob, 'proveedores.xlsx');
            this.store.dispatch(new FileActions.ExportProformaSuccess());
          },
          err => {
            this.store.dispatch(new FileActions.ExportProformaFail());
          }
        );
    }
  }

  exportPosters(data) {
    return this.http
      .get(`${API}/files/export-poster?FollowId=${data}`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          // const blob = response.body;
          // FileSaver.saveAs(blob, 'cartelería.xlsx');
          this.store.dispatch(new FileActions.DownloadPostersSuccess());
        },
        err => {
          this.store.dispatch(new FileActions.DownloadPostersFail(err));
        }
      );
  }

  generateBook(FollowId, uniqId, full, isAlternative, udnCountry?) {
    return this.http
      .get(
        `${API}follows/${FollowId}/export?type=book&uniqId=${uniqId}&full=${full}&isAlternative=${isAlternative}&udnCountry=${udnCountry}`,
        {
          observe: 'response'
        }
      )
      .subscribe(
        response => {
          this.store.dispatch(
            new NewProductFileActions.GenerateBookUpdate({
              status: 'pending',
              // message: 'Generando book...',
              uniqId: uniqId
            })
          );
        },
        err => {
          this.store.dispatch(new NewProductFileActions.GenerateBookFail());
        }
      );
  }

  downloadBook(downloadUrl, name) {
    return this.http
      .get(downloadUrl, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, name);
          this.store.dispatch(new NewProductFileActions.DownloadBookSuccess());
        },
        err => {
          this.store.dispatch(new NewProductFileActions.DownloadBookFail());
        }
      );
  }

  getShippingTimes() {
    return this.http.get<any[]>(`${API}shipping_times`);
  }

  getPlannerIds() {
    return this.http.get<any[]>(`${API}planner_ids`);
  }

  getFollowCountries(followId) {
    return this.http.get<Country[]>(`${API}follows/${followId}/countries`);
  }

  createFollowSetting(followId, data) {
    return this.http.post<any>(`${API}follows/${followId}/settings`, data);
  }

  deleteFollowArrival(FollowId: number, arrivalId: number) {
    return this.http.delete<any>(
      `${API}follows/${FollowId}/arrivals?ArrivalId=${arrivalId}`
    );
  }

  updateFollowArrival(data: any) {
    return this.http.put<any>(`${API}follows/${data.FollowId}/arrivals`, data);
  }

  migrateFollow(id: number, payload: any) {
    return this.http.post<any>(`${API}follows/${id}/migrate`, payload);
  }

  getAvailableSeasons(filters?: any) {
    let query = "";
    if (filters) {
      const params = [];
      if (filters.year) params.push(`year=${filters.year}`);
      if (filters.followGroupId) params.push(`followGroupId=${filters.followGroupId}`);
      if (filters.type) params.push(`type=${filters.type}`);
      if (params.length) query = "?" + params.join("&");
    }
    return this.http.get<any>(`${API}follows/available-seasons${query}`);
  }

  getMigrateParentCandidates(FollowId: number) {
    return this.http.get<any>(`${API}follows/${FollowId}/migrate-candidates`);
  }

  addFollowArrival(data: any) {
    return this.http.post<any>(`${API}follows/${data.FollowId}/arrivals`, data);
  }

  getFollowArrivals(FollowId: number) {
    return this.http.get<any>(`${API}follows/${FollowId}/arrivals`);
  }

  getPorts() {
    return this.http.get<Port[]>(`${API}ports`);
  }

  updateSizeBreak(data) {
    return this.http.put<ProductCountry[]>(`${API}products/countries`, data);
  }

  getProductCountries(productId: number) {
    return this.http.get<ProductCountry[]>(
      `${API}products/${productId}/countries`
    );
  }

  getProductCountriesByFollow(
    followId: number,
    countryId?: number,
    countryDepartmentId?: any,
    CountryBuyerId?: number,
    businessUnit?: any,
    typeHierarchy?: any,
    DestinationCenterId?: any,
    component?: any
  ) {
    return this.http.get<ProductCountry[]>(
      `${API}product_countries?${followId ? 'FollowId=' + followId : ''}${
        followId && countryId ? '&' : ''
      }${countryId ? 'CountryId=' + countryId : ''}${
        (countryId && countryDepartmentId) || (followId && countryDepartmentId)
          ? '&'
          : ''
      }${
        countryDepartmentId ? 'CountryDepartmentId=' + countryDepartmentId : ''
      }${
        (countryId && CountryBuyerId) ||
        (followId && CountryBuyerId) ||
        (countryDepartmentId || CountryBuyerId)
          ? '&'
          : ''
      }${CountryBuyerId ? 'CountryBuyerId=' + CountryBuyerId : ''}${
        businessUnit ? '&businessUnit=' + businessUnit : ''
      }${
        (businessUnit && typeHierarchy) || (CountryBuyerId && typeHierarchy)
          ? '&'
          : ''
      }${typeHierarchy ? 'typeHierarchy=' + typeHierarchy : ''}${
        DestinationCenterId ? '&DestinationCenterId=' + DestinationCenterId : ''
      }${component ? '&component=' + component : ''}`
    );
  }

  getProductFiles(productId: number) {
    return this.http.get<File[]>(`${API}files?ProductId=${productId}`);
  }

  getBrands() {
    return this.http.get<Brand[]>(`${API}brands`);
  }

  getNotifications() {
    return this.http.get<Notification[]>(`${API}notifications`);
  }

  updateNotification(id, data) {
    return this.http.put<Notification>(`${API}notifications/${id}`, data);
  }

  massiveLink(file, uploadType, data?) {
    return this.http.post<string>(`${API}files`, {
      mimeType: file.type,
      FileableType: uploadType,
      enrichData: data
    });
  }

  getUploadLink(FollowId, file, uploadType?, order?) {
    uploadType = uploadType || 'follow';
    let mimeType = file.type;

    let typeUpload;
    if (uploadType === 'image') {
      typeUpload = 'image';
    }

    if (!mimeType) {
      const splittedName = file.name.toString().split('.');
      const ext = splittedName[splittedName.length - 1]
        .toString()
        .toLowerCase();

      const mappedExtensions = {
        xlsx:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        xls: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      };

      if (mappedExtensions[ext]) {
        mimeType = mappedExtensions[ext];
      }

      // console.log({ splittedName, ext, mimeType });
    }

    if (uploadType === 'follow_regional_unit') {
      return this.http.post<string>(`${API}files`, {
        mimeType,
        FileableType: uploadType,
        FileableId: FollowId
      });
    }

    if (uploadType === 'bookImage') {
      return this.http.post<string>(`${API}files`, {
        mimeType,
        FileableType: uploadType,
        FileableId: FollowId
      });
    }

    return this.http.post<string>(
      `${API}files`,
      uploadType === 'follow'
        ? { mimeType, FollowId, order }
        : {
            mimeType,
            FileableType: 'Follow',
            FileableId: FollowId,
            typeUpload: typeUpload,
            order
          }
    );
  }

  getUploadLinkMassiveColors(FollowId, file, uploadType?) {
    // console.log('LLAMADO A LA API');
    uploadType = uploadType || 'Color';
    const mimeType = file.type;

    const options = {
      metadata: {
        processType: 'BulkColorUpload'
      },
      mimeType,
      FileableType: 'Follow',
      FileableId: FollowId
    };

    // const fileId = file.id;
    // console.log('FILE -->', FollowId);
    return this.http.post<string>(`${API}files`, options);
  }

  getColorFileUploadLink(ColorId, file, featured) {
    const mimeType = file.type;
    const name = file.name;

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      featured,
      FileableType: 'Color',
      FileableId: ColorId
    });
  }

  // getBrandUploadLink(BrandId, file, uploadType?) {
  //   uploadType = uploadType || 'follow';
  //   const mimeType = file.type;

  //   return this.http.post<string>(
  //     `${API}files`,
  //     uploadType === 'brand'
  //       ? { mimeType, BrandId }
  //       : { mimeType, FileableType: 'Brand', FileableId: BrandId }
  //   );
  // }

  getFileUploadLink(owner, file, featured) {
    const mimeType = file.type;
    const name = file.name;

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      ...owner,
      featured
    });
  }

  getImplantationUploadLink(followId, file) {
    const mimeType = file.type;
    const name = file.name;
    const FileableType = 'Follow';

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      FileableType,
      FileableId: followId,
      metadata: {
        processType: 'LoadImplantation'
      }
    });
  }

  getBannerUploadLink(followId, file, followType) {
    const mimeType = file.type;
    const name = file.name;
    const position =
      (name &&
        name.split('_')[1] &&
        name.split('_')[1].split('.') &&
        name.split('_')[1].split('.')[0]) ||
      1;

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      FileableType: followType,
      FileableId: followId,
      metadata: {
        processType: 'LoadBanner',
        position: position
      }
    });
  }

  changeNameFollow(name, followId) {
    return this.http.put(`${API}follows/change-name/${followId}`, name);
  }

  getColorUploadLink(followId, file) {
    const mimeType = file.type;
    const name = file.name;
    const FileableType = 'Follow';
    console.log('FOLLOW ID', followId);
    console.log('FILE', file);

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      FileableType,
      FileableId: followId,
      status,
      metadata: {
        processType: 'LoadColors'
      }
    });
  }
  getRetroplanningUploadLink(followId, file) {
    const mimeType = file.type;
    const name = file.name;
    const FileableType = 'Retroplanning';

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      FileableType,
      FileableId: followId,
      // status,
      metadata: {
        processType: 'LoadRetroplanning'
      }
    });
  }

  notifyImplantationUpload(id, metadata?) {
    const { processType } = metadata;

    return this.http.put<File>(
      `${API}files/${id}?processType=${processType || null}`,
      {
        status: 1,
        metadata
      }
    );
  }

  getProductFileUploadLink(ProductId, file, featured, position?) {
    const mimeType = file.type;
    const name = file.name;
    let metadata = {};

    if (position) {
      metadata['position'] = position;
    }

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      ProductId,
      featured,
      metadata
    });
  }

  getProvidersUploadLink(file) {
    const mimeType = file.type;
    const name = file.name;

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name
    });
  }

  getProformasUploadLink(file, data?) {
    const mimeType = file.type;
    const name = file.name;
    let FileableType = 'Proforma';
    let ProviderId;
    if (data && data.mode === 'Sustainability') {
      FileableType = 'Sustainability';
      ProviderId = data.ProviderId;
    }

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      FileableType,
      ProviderId
    });
  }

  getDetailProformasUploadLink(file, followId) {
    const mimeType = file.type;
    const name = file.name;
    let FileableType = 'DetailProformas';
    let ProviderId;

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      FileableType,
      ProviderId,
      FollowId: followId
    });
  }

  getPortUploadLink(file, data?) {
    const mimeType = file.type;
    const name = file.name;
    let FileableType = 'Port';

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      FileableType
    });
  }

  getShippingTimeUploadLink(file, data?) {
    const mimeType = file.type;
    const name = file.name;
    let FileableType = 'ShippingTime';
    let ProviderId;

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      FileableType,
      ProviderId
    });
  }

  getAuxiliarShippingMarksUploadLink(file, followId) {
    const mimeType = file.type;
    const name = file.name;
    const FileableType = 'AuxiliarShippingMarks';
    const FollowId = followId;

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      FileableType,
      FollowId
    });
  }

  downloadShippingTimes() {
    return this.http
      .get(`${API}shipping_times/export`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, 'Detalle-origen.xlsx');
          this.store.dispatch(new ShippingTimeActionTypes.ExportSuccess());
        },
        err => {
          this.store.dispatch(
            new ProformaActionTypes.ProformasDetailDownloabledFail(err)
          );
        }
      );
  }

  refreshShippingTimes() {
    return this.http.get(`${API}shipping_times/refresh`).subscribe(
      response => {
        this.store.dispatch(
          new ShippingTimeActionTypes.RefreshShippingTimesSuccess()
        );
      },
      err => {
        this.store.dispatch(
          new ProformaActionTypes.ProformasDetailDownloabledFail(err)
        );
      }
    );
  }

  getHierarchyCountryUploadLink(file) {
    const mimeType = file.type;
    const name = file.name;
    const FileableType = 'Hierarchy Country';

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      FileableType,
      hierarchyCountry: true
    });
  }

  getHierarchyPlannerUploadLink(file) {
    const mimeType = file.type;
    const name = file.name;
    const FileableType = 'Hierarchy Planner';

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      FileableType,
      hierarchyPlanner: true
    });
  }

  getHierarchyPlannerFoodUploadLink(file) {
    const mimeType = file.type;
    const name = file.name;
    const FileableType = 'HierarchyPlannerFood';

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      FileableType
    });
  }

  uploadFile(link, file) {
    return this.http.put<any>(`${link}`, file);
  }

  getFollowYears() {
    return this.http.get<any>(`${API}follows/years/get`);
  }

  uploadFileProformas(data) {
    return this.http.put<any>(`${API}files/proformas`, data);
  }

  uploadFileDetailProformas(data) {
    return this.http.put<any>(`${API}files/detail-proformas`, data);
  }

  uploadFileShippingTimes(data) {
    return this.http.put<any>(`${API}shipping_times/load`, data);
  }

  finishExportPosters(data, followId) {
    return this.http
      .get(data, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Cartelería - ${followId}.zip`);
          this.store.dispatch(new FileActions.DownloadPostersSuccess());
        },
        err => {
          this.store.dispatch(new FileActions.DownloadPostersFail(err));
        }
      );
  }

  uploadFilePort(data) {
    const newData = {
      fileId: data
    };
    return this.http.put<any>(`${API}ports/upload`, newData);
  }

  uploadFileDiscrepancies(link, file) {
    return this.http.put<any>(`${link}`, file);
  }

  uploadFollowFile(link, file) {
    return this.http.put<any>(`${link}`, file);
  }

  deleteFile(id) {
    return this.http.delete<any>(`${API}files/${id}`);
  }

  notifyFileUpload(id, metadata?, typeFile?, order?, OriginId?) {
    if (!metadata) {
      metadata = {};
    }

    const { processType } = metadata;

    this.store.dispatch(new NewProductFileActions.ClearStateProductFilePage());
    return this.http.put<File>(
      `${API}files/${id}?processType=${processType || null}`,
      {
        status: 1,
        followType: metadata.followType,
        metadata,
        order,
        typeFile,
        OriginId
      }
    );
  }

  importFileProducts(id, typeLoad?) {
    let status = {};
    if (typeLoad === 'loadOCM') {
      status = {
        status: 3
      };
    } else {
      status = {
        status: 2
      };
    }
    return this.http.put<File>(`${API}files/${id}`, status);
  }

  getAutocomplete(table: string, column: string, filters: any) {
    const filter = filters
      ? Object.keys(filters).reduce((st, key, index) => {
          if (index === 0) {
            return `${st}?${key}=${filters[key]}`;
          } else {
            return `${st}&${key}=${filters[key]}`;
          }
        }, '')
      : '';

    return this.http.get<any[]>(
      `${API}autocomplete/${table}/${column}${filter}`
    );
  }

  getProductCollectionsByFollow(FollowId: number) {
    return this.http.get<any[]>(
      `${API}autocomplete/products/metadata.collection?FollowId=${FollowId}`
    );
  }

  getProductTagsByFollow(FollowId: number) {
    return this.http.get<any[]>(
      `${API}autocomplete/products/tags?FollowId=${FollowId}`
    );
  }

  createProductColor(productId, colorId) {
    return this.http.post<any>(`${API}products/${productId}/colors`, {
      ColorId: colorId
    });
  }

  fetchProducts(followId) {
    return this.http.get<any>(`${API}products/${followId}/purchase-summary`);
  }

  fetchTroncals(followId) {
    return this.http.get<any>(`${API}products/${followId}/troncals`);
  }

  bulkUpdateProductShipments(data) {
    return this.http.put<ProductShipment[]>(
      `${API}product_countries/shipments`,
      data
    );
  }

  bulkUpdateProductShipmentsNew(data) {
    return this.http.put<ProductShipment[]>(
      `${API}product_countries/shipments/update-web`,
      data
    );
  }

  bulkTransferProductShipments(data: any) {
    return this.http.post<ProductShipment[]>(
      `${API}product_countries/shipments/transfer`,
      data
    );
  }

  getProuctArrivalsByFollow(
    followId: number,
    countryId: number,
    proformaId: number,
    ProductId: number
  ) {
    let query = `FollowId=${followId}`;
    query = countryId ? `${query}&CountryId=${countryId}` : query;
    query = proformaId ? `${query}&ProformaId=${proformaId}` : query;
    query = ProductId ? `${query}&ProductId=${ProductId}` : query;

    return this.http.get<any>(`${API}product_countries/arrivals?${query}`);
  }

  getProductShipmentsByFollow(
    followId: number,
    countryId: number,
    proformaId: number,
    ProductId: number
  ) {
    let query = `FollowId=${followId}`;
    query = countryId ? `${query}&CountryId=${countryId}` : query;
    query = proformaId ? `${query}&ProformaId=${proformaId}` : query;
    query = ProductId ? `${query}&ProductId=${ProductId}` : query;

    return this.http.get<any>(`${API}product_countries/shipments?${query}`);
  }

  removeProductColor(productId, colorId) {
    return this.http.delete<any>(
      `${API}products/${productId}/colors/${colorId}`
    );
  }

  updateProductCountry(id, data) {
    return this.http.put<ProductCountry>(`${API}product_countries/${id}`, data);
  }

  bulkUpdateProductCountry(
    ProductIds,
    CountryId,
    businessUnit,
    data,
    DestinationCenterId
  ) {
    return this.http.put<ProductCountry[]>(`${API}product_countries`, {
      ProductIds,
      CountryId,
      businessUnit,
      ...data,
      DestinationCenterId
    });
  }

  getLogs(page?: number) {
    const query = `page=${page || 0}`;

    return this.http.get<any>(`${API}revisions?${query}`, {
      observe: 'response'
    });
  }

  bulkTransferProductProformas(data: any) {
    // console.log('databack', data);
    return this.http.post<ProductShipment[]>(
      `${API}product_countries/shipments/transferProforma`,
      data
    );
  }

  exportShippingmarks(ProviderId, FollowId, filename) {
    const query = `ProviderId=${ProviderId}&FollowId=${FollowId}`;

    return this.http
      .get(`${API}shippingmarks/export1?${query}`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          // FileSaver.saveAs(blob, `${filename}.xlsx`);
          FileSaver.saveAs(blob, filename);
          console.log('filename==>', filename);
          this.store.dispatch(
            new ShippingmarksActions.ShippingmarksDownloadSuccess()
          );
        },
        err => {
          this.store.dispatch(
            new ShippingmarksActions.ShippingmarksDownloadFail(err)
          );
        }
      );
  }
  exportAllShippingmarks(FollowId, UserId, data) {
    const query = `FollowId=${FollowId}&UserId=${UserId}`;

    return this.http
      .post(`${API}shippingmarks/exportMassiveShippingMarks?${query}`, data)
      .subscribe(
        response => {
          console.log(response);
        },
        err => {
          this.store.dispatch(
            new ShippingmarksActions.ShippingmarksDownloadFail(err)
          );
        }
      );
  }
  exportShippingmarksPDF(ProviderId, FollowId, filename) {
    const query = `ProviderId=${ProviderId}&FollowId=${FollowId}`;

    return this.http
      .get(`${API}shippingmarks/export?${query}`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, filename);
          this.store.dispatch(
            new ShippingmarksActions.ShippingmarksDownloadSuccess()
          );
        },
        err => {
          this.store.dispatch(
            new ShippingmarksActions.ShippingmarksDownloadFail(err)
          );
        }
      );
  }

  ExportPurchaseSummarySuplier(
    FollowId,
    ProviderId,
    filename,
    types,
    OriginId?,
    RegionalId?,
    enableShipment?,
    exportDiscrepanciesId?
  ) {
    let query = `filename=${filename}&ProviderId=${ProviderId}&Types=${types}`;
    query = `exportDiscrepanciesId=${exportDiscrepanciesId}&filename=${filename}&ProviderId=${ProviderId}&Types=${types}${
      OriginId ? '&OriginId=' + OriginId : ''
    }${RegionalId ? '&RegionalId=' + RegionalId : ''}
    `;

    query = enableShipment
      ? `${query}&enableShipment=${enableShipment}`
      : query;

    return this.http
      .get(`${API}follows/${FollowId}/purchase_summary_supplier?${query}`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {},
        err => {
          this.store.dispatch(
            new ReportsActions.ExportPurchaseSummaryFail(err)
          );
        }
      );
  }

  exportPurchaseSummary(
    FollowId,
    ProviderId,
    filename,
    types,
    OriginId?,
    RegionalId?,
    enableShipment?,
    exportDiscrepanciesId?
  ) {
    let query = `filename=${filename}&ProviderId=${ProviderId}&Types=${types}`;
    query = `exportDiscrepanciesId=${exportDiscrepanciesId}&filename=${filename}&ProviderId=${ProviderId}&Types=${types}${
      OriginId ? '&OriginId=' + OriginId : ''
    }${RegionalId ? '&RegionalId=' + RegionalId : ''}
    `;

    query = enableShipment
      ? `${query}&enableShipment=${enableShipment}`
      : query;

    return this.http
      .get(`${API}follows/${FollowId}/purchase_summary?${query}`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          // const blob = response.body;
          // FileSaver.saveAs(blob, filename);
          // this.store.dispatch(
          //   new ReportsActions.ExportPurchaseSummarySuccess()
          // );
        },
        err => {
          this.store.dispatch(
            new ReportsActions.ExportPurchaseSummaryFail(err)
          );
        }
      );
  }

  downloadDiscrepancies(downloadUrl, name) {
    return this.http
      .get(downloadUrl, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, name);
          this.store.dispatch(
            new ReportsActions.ExportDiscrepanciesDownloadSuccess()
          );
        },
        err => {
          this.store.dispatch(
            new ReportsActions.ExportDiscrepanciesDownloadFail(err)
          );
        }
      );
  }

  exportDiscrepancy(ProviderId, filename) {
    const query = `ProviderId=${ProviderId}`;

    return this.http
      .get(`${API}:ProviderId/discrepancias/export?${query}`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, filename);
          this.store.dispatch(
            new DiscrepancyActions.DiscrepancyDownloadSuccess()
          );
        },
        err => {
          this.store.dispatch(
            new DiscrepancyActions.DiscrepancyDownloadFail(err)
          );
        }
      );
  }

  exportProformaList(FollowId, CountryId, filename, UserId) {
    const query = `CountryId=${CountryId}&UserId=${UserId}`;

    return this.http
      .get(`${API}proformas/${FollowId}/export_proforma_list?${query}`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, filename);
          this.store.dispatch(new ReportsActions.ExportProformaListSuccess());
        },
        err => {
          this.store.dispatch(new ReportsActions.ExportProformaListFail(err));
        }
      );
  }
  eportShippingMarksXlsx(data) {
    // const query = `CountryId=${CountryId}&UserId=${UserId}`;
    return this.http
      .post(`${API}shippingmarks/export-master`, data, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, 'Maestra-Códigos-Shipping-Marks.xlsx');
          this.store.dispatch(
            new ReportsActions.EportShippingMarksXlsxSuccess()
          );
        },
        err => {
          this.store.dispatch(new ReportsActions.ExportProformaListFail(err));
        }
      );
  }

  getDiscrepancyFileUploadLink(
    FollowId,
    ProviderId,
    file,
    followType,
    OriginId?
  ) {
    const mimeType = file.type;
    const name = file.name;

    return this.http.post<string>(`${API}files`, {
      mimeType,
      name,
      FileableId: ProviderId,
      FileableType: 'Provider',
      metadata: {
        FollowId,
        ProviderId,
        followType,
        OriginId,
        processType: 'ProcessDiscrepancies'
      }
    });
  }

  acceptDiscrepanciesChanges(FileId: string) {
    return this.http.put<File>(`${API}files/${FileId}`, { status: 2 });
  }

  getArrivalChartsData(FollowId: number) {
    return this.http.get(`${API}follows/${FollowId}/reports/arrivals`);
  }

  getProductShipmentsByShowroom(
    FollowId,
    CountryDepartmentId,
    CountryId,
    businessUnit,
    typeHierarchy,
    DestinationCenterId
  ) {
    return this.http.get<ProductShipment[]>(
      `${API}product_countries/shipments/${FollowId}/showroom/productShipments?${
        CountryDepartmentId ? 'CountryDepartmentId=' + CountryDepartmentId : ''
      }${CountryId ? '&CountryId=' + CountryId : ''}${
        businessUnit ? '&businessUnit=' + businessUnit : ''
      }${typeHierarchy ? '&typeHierarchy=' + typeHierarchy : ''}${
        DestinationCenterId ? '&DestinationCenterId=' + DestinationCenterId : ''
      }`
    );
  }

  downloadProfilesXLSX() {
    return this.http
      .get(`${API}profiles/export`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Perfiles.xlsx`);
        },
        err => {
          console.log(err);
          //this.store.dispatch(new FileActions.ExportFollowFail());
        }
      );
  }

  exportHierarchyCountry(data) {
    // const query = type ? `?type=${type}` : '';
    return this.http
      .get(
        `${API}country_departments/export?CountryId=${
          data.CountryId
        }&BusinessId=${data.BusinessId}`,
        {
          responseType: 'blob',
          observe: 'response'
          // ConutryId: data.CountryId,
          // BusinessId: data.BusinessId
        }
      )
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(
            blob,
            `Jerarquía_Local_${data.selectedBusinessCountry.name}_${
              data.countryName
            }`
          );
          this.store.dispatch(new FileActions.ExportHierarchyCountrySuccess());
        },
        err => {
          this.store.dispatch(new FileActions.ExportHierarchyCountryFail());
        }
      );
  }

  exportHierarchyPlanner(data) {
    return this.http
      .get(`${API}departments/export/file`, {
        responseType: 'blob',
        observe: 'response'
        // ConutryId: data.CountryId,
        // BusinessId: data.BusinessId
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Jerarquía_Planner`);
          this.store.dispatch(new FileActions.ExportHierarchyPlannerSuccess());
        },
        err => {
          this.store.dispatch(new FileActions.ExportHierarchyPlannerFail());
        }
      );
  }

  exportHierarchyPlannerFood(data) {
    return this.http
      .get(`${API}departmentsFood/export/file`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Jerarquía_Planner_Food`);
          this.store.dispatch(
            new FileActions.ExportHierarchyPlannerFoodSuccess()
          );
        },
        err => {
          this.store.dispatch(new FileActions.ExportHierarchyPlannerFoodFail());
        }
      );
  }

  createAccessToken(code) {
    return this.http.post<string>(`${API}auth/token`, {
      code
    });
  }

  //Saga Mirrors
  getProductCountryMirrors(ProductId) {
    return this.http.get(
      `${API}product_countries/product_country_mirrors/${ProductId}`
    );
  }

  getProductShipmentMirrors(ProductId) {
    return this.http.get<ProductShipment[]>(
      `${API}product_countries/shipments/${ProductId}/shipment_mirrors`
    );
  }

  exportFollowDiscrepancies(FollowId, filename, filter) {
    return this.http
      .get(
        `${API}follows/${FollowId}/discrepancies?${
          filter.enableShipment ? 'filter=' + filter.enableShipment : ''
        }&${
          filter.selectedBuyer ? 'selectedBuyer=' + filter.selectedBuyer : ''
        }&${
          filter.selectedOrigin ? 'selectedOrigin=' + filter.selectedOrigin : ''
        }`
      )
      .subscribe(
        response => {
          this.store.dispatch(
            new ReportsActions.ExportFollowDiscrepanciesUpdate({
              status: 'pending',
              message: 'Generando discrepancias...'
            })
          );
        },
        err => {
          this.store.dispatch(
            new ReportsActions.ExportFollowDiscrepanciesFail(err)
          );
        }
      );
  }

  downloadDiscrepanciesZip(downloadUrl, filename) {
    return this.http
      .get(downloadUrl, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, filename);
        },
        err => {
          this.store.dispatch(
            new ReportsActions.ExportFollowDiscrepanciesFail(err)
          );
        }
      );
  }

  downloadNewColor(FileId, FollowId) {
    return this.http
      .get(`${API}/follows/${FollowId}/colors/${FileId}/export`, {
        responseType: 'blob',
        observe: 'response'
        //  FileId: FileId
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Nuevos_colores.xlsx`);
        },
        err => {
          console.log(err);
          //this.store.dispatch(new FileActions.ExportFollowFail());
        }
      );
  }

  downloadRetroplanning(followId) {
    // `${API}follows/${followId}/retroplanning/${data.id}`,
    return this.http
      .get(`${API}/retroplanning/${followId}/export_retroplanning`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Retroplanning.xlsx`);
          this.store.dispatch(new FileActions.DownloadRetroplanningSucces());
        },
        err => {
          this.store.dispatch(new FileActions.DownloadRetroplanningFail(err));
        }
      );
  }

  downloadCoversGroup(downloadUrl, name) {
    return this.http
      .get(downloadUrl, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, name);
          this.store.dispatch(
            new CoverActionTypes.ExportGroupCoversDownloadSuccess()
          );
        },
        err => {
          this.store.dispatch(
            new CoverActionTypes.ExportGroupCoversDownloadFail(err)
          );
        }
      );
  }

  exportCoversGroup(filter) {
    console.log('SERVICE_exportCoversGroup');
    return this.http.post(`${API}covers/export`, filter).subscribe(
      response => {
        this.store.dispatch(
          new CoverActionTypes.ExportGroupCoversUpdate({
            status: 'pending',
            message: 'Generando Carátulas...'
            /* exportGroupId: filter.exportGroupId,
            RegionalId: filter.RegionalId || null,
            OriginId: filter.OriginId || null,
            enableShipment: filter.enableShipment || null */
          })
        );
      },
      err => {
        this.store.dispatch(new CoverActionTypes.ExportGroupCoversFail(err));
      }
    );
  }
}
